import { useMemo } from 'react';
import formatUnixTimestamp from '../../../../utils/formatUnixTimestamp';
import { STATE_COLORS, THERMOCOUPLE_STATE } from '../../constants';
import { ChannelState } from '../../../../enums/channel-state.enum';

export interface ItemCircleStateProps {
  timestamp?: number;
  isFaulted?: boolean;
  state?: ChannelState;
}

export const ItemCircleState = ({ timestamp, isFaulted, state }: ItemCircleStateProps) => {
  const currentColor = useMemo(() => {
    if (isFaulted) {
      return STATE_COLORS[ChannelState.FAULTED];
    }

    if (state) {
      return STATE_COLORS[state];
    }

    return STATE_COLORS[THERMOCOUPLE_STATE];
  }, [state, isFaulted]);

  return (
    <div className="c-item-circle-state">
      {!!timestamp && (
        <div className="absolute hidden w-auto translate-y-[-18px] group-hover:block max-md:right-[10px] md:translate-x-[-46%] md:translate-y-[-22px]">
          <div className="bg-bla bottom-full right-0 whitespace-nowrap rounded border border-foggy-mist bg-gray-3 px-1 py-1 text-[10px] leading-[10px] md:px-2 md:text-xs/3">
            {formatUnixTimestamp(timestamp)}
          </div>
        </div>
      )}
      <span
        style={{ color: currentColor }}
        className="relative bottom-[2px] cursor-pointer text-[8px] leading-[8px] md:text-xs/3"
      >
        ⬤
      </span>
    </div>
  );
};
